<template>
    <div class="content">
        <div class="newBg">
            <!-- <div class="vantLine"></div> -->
            <div class="vanTabs">
                <van-tabs ellipsis :line-width="lineWidth" v-model="active" border @change="() => changeTabs()">
                    <van-tab v-for="(tab, index) in tabArray" :key="index" :title="tab">
                        <div class="padding20X paddingX14 van-bgcolor-white">
                            <!-- tab1 BRC20 -->
                            <template v-if="index === 0">
                                <div>
                                    <brc20Tab ref="brc20TabRef" @showAdPopUp="showAdPopUp" @showTransferPopUpBrc20="showTransferPopUpBrc20"></brc20Tab>
                                </div>
                            </template>
                            <!-- tab2 ARC20 -->
                            <template v-if="index === 1">
                                <div class="tab2">
                                    <artTab ref="artTabRef"></artTab>
                                </div>
                            </template>
                            <!-- tab3 SRC20 -->
                            <template v-if="index === 2">
                                <div class="tab2">
                                    <artTab ref="artTabRef"></artTab>
                                </div>
                            </template>
                            <!-- tab4 PIPE -->
                            <template v-if="index === 3">
                                <div>
                                    <dmtTab ref="dmtTabRef" @showAdPopUp="showAdPopUp" @showTransferPopUp="showTransferPopUp"></dmtTab>
                                </div>
                            </template>
                            <!-- tab5 TAP --> 
                            <template v-else-if="index === 4">
                                <div class="tab2">
                                    <artTab ref="artTabRef"></artTab>
                                </div>
                            </template>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
            <!-- 底部按钮 -->
            <div v-show="isShowBtn">
                <div v-if="active != 4" class="footerBtns">
                    <!-- 取消 -->
                    <div class="cancel" @click="goAppBack()">
                        <van-button>{{ $t("300111") }}</van-button>
                    </div>
                    <!-- 下一步 -->
                    <div class="next">
                        <van-button @click="next()" native-type="submit" color="#000">下一步</van-button>
                    </div>
                </div>
                <div v-else class="footerBtns">
                    <!-- 取消 -->
                    <div class="cancel">
                        <van-button>{{ $t("300111") }}</van-button>
                    </div>
                    <!-- 下一步 -->
                    <div class="nextTab2">
                        <van-button disabled>下一步</van-button>
                    </div>
                </div>
            </div>
        </div>
        <cu-popup ref="selectAdRef" :styleObj="{ minHeight: '30%', maxHeight: '80%' }" :title="'接收地址'" @confirm="changeAd()" @close="clearCurtSelect()">
            <div slot="content">
                <div class="my-ad">
                    <span class="my-ad-text">我的地址</span>
                    <van-cell-group>
                        <van-cell v-for="(item, index) in myAds" :title="item.ad" :key="index" @click="handleSelect(item.ad)">
                            <van-icon v-if="currentSelectVal === item.ad" slot="right-icon" name="success" />
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class="lately-record">
                    <span class="lately-record-text">
                        最近记录
                    </span>
                    <van-cell-group>
                        <van-cell class="rd-cell" v-for="(item, index) in getRd" :title="item" :key="index" @click="handleSelect(item)">
                            <van-icon v-if="currentSelectVal === item" slot="right-icon" name="success" />
                        </van-cell>
                    </van-cell-group>
                </div>
            </div>
        </cu-popup>
        <cu-popup ref="selectCyRef" :styleObj="{ minHeight: '30%', maxHeight: '80%' }" :title="getTransferTitle" @confirm="changeCy()" @close="clearCurtSelect()">
            <div slot="content">
                <van-cell-group>
                    <van-cell v-for="(item, index) in transferList" :title="item" :key="index" :class="[
              { 'select-cy-active': currentSelectVal === item },
              'select-cy'
            ]" @click="handleSelect(item)">
                        <van-icon v-if="currentSelectVal === item" slot="right-icon" name="success" />
                    </van-cell>
                </van-cell-group>
            </div>
        </cu-popup>
        <cu-popup ref="selectCyRefBrc20" :styleObj="{ minHeight: '30%', maxHeight: '80%' }" :title="getTransferTitle" @confirm="changeCyBrc20()" @close="clearCurtSelect()">
            <div slot="content">
                <van-cell-group>
                    <van-cell v-for="(item, index) in Brc20TransferList" :title="item" :key="index" :class="[
              { 'select-cy-active': currentSelectVal === item },
              'select-cy'
            ]" @click="handleSelect(item)">
                        <van-icon v-if="currentSelectVal === item" slot="right-icon" name="success" />
                    </van-cell>
                </van-cell-group>
            </div>
        </cu-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Tab, Tabs, Button, Icon, Popup, Cell, CellGroup } from 'vant'
import dmtTab from './compontents/dmtTab.vue'
import brc20Tab from './compontents/brc20Tab.vue'
import artTab from './compontents/artTab.vue'
import cuPopup from './compontents/cuPopup.vue'

export default {
    name: 'Inscription',
    components: {
        dmtTab,
        brc20Tab,
        artTab,
        CuPopup: cuPopup,
        vanTab: Tab,
        vanTabs: Tabs,
        vanIcon: Icon,
        VanButton: Button,
        VanPopup: Popup,
        VanCell: Cell,
        VanCellGroup: CellGroup,
    },
    data() {
        return {
            tabArray: ['BRC20','ARC20','SRC20','PIPE', 'TAP'],
            active: 0,
            transferType: '',
            currentSelectVal: '',
            transferList: ['$PIPE', '$ETCH:789', '$ETCH:888'],
            Brc20TransferList: ['sats','rats','piin'],
            myAds: [
                {
                    ad: 'bc1ppnagslwuxwhmhv9zw5eemnckde3t90394eqwv3z24wwc38zsk366v523',
                },
            ],
            lineDom: null,
            lineWidth: '78px',
            isShowBtn: true,
            docmHeight: document.documentElement.clientHeight, //默认屏幕高度
            showHeight: document.documentElement.clientHeight, //实时屏幕高度
        }
    },
    created() {},
    mounted() {
        this.lineDom = document.querySelector('.van-tabs__line')
        this.lineDom.style.left = '-3%'
        // window.onresize监听页面高度的变化
        window.onresize = () => {
            this.showHeight = document.body.clientHeight
            // return (() => {
            //   this.showHeight = document.body.clientHeight;
            // })();
        }
    },
    beforeDestroy() {},
    computed: {
        ...mapGetters([
            'token',
            'styleType',
            'isDirection',
            'languageName',
            'language',
            'isApp',
        ]),
        getRd() {
            return Array.from({ length: 2 }).map(
                (_, idx) => ` ${this.myAds[0].ad + idx}`
            )
        },
        getTransferTitle() {
            const titleMaps = {
                currency: '选择币种',
                utxo: '选择UTXO',
            }
            return titleMaps[this.transferType]
        },
    },
    watch: {
        showHeight() {
            if (this.docmHeight > this.showHeight) {
                this.isShowBtn = false
                return
            }
            this.isShowBtn = true
        },
    },
    methods: {
        goAppBack() {
            this.$jsBridge.callHandler(
                this.$jsBridgeCmd.goBack,
                {},
                (data) => {}
            )
        },
        showAdPopUp(val) {
            // const { address } = this.$refs.dmtTabRef[0].getTabFormValues();
            // console.log('values', values)
            if (val) {
                this.currentSelectVal = val
            }
            this.$refs.selectAdRef.open()
        },
        showTransferPopUp(type, val) {
            console.log('进没进');
            this.transferType = type
            if (val) {
                this.currentSelectVal = val
            }
            this.$refs.selectCyRef.open()
        },
        showTransferPopUpBrc20(type, val) {
            console.log('进没进BRC20');
            this.transferType = type
            if (val) {
                this.currentSelectVal = val
            }
            this.$refs.selectCyRefBrc20.open()
        },
        handleSelect(val) {
            console.log(val,'--val--');
            if (this.currentSelectVal === val) {
                this.currentSelectVal = ''
                return
            }
            this.currentSelectVal = val
        },
        changeAd() {
            // 根据当前活动的标签页索引决定要使用的ref
            let currentRef;
            if (this.active === 3) { // 假设dmtTab对应的标签索引是3
                currentRef = this.$refs.dmtTabRef;
            } else if (this.active === 0) { // 假设brc20Tab对应的标签索引是0
                currentRef = this.$refs.brc20TabRef;
            }
            // 使用选中的ref调用changeSelectData方法
            currentRef[0].changeSelectData(
                'address',
                this.currentSelectVal
            );

            // 可选：重置currentSelectVal
            // this.currentSelectVal = "";
        },
        changeCy() {
            // TODO 币种/utxo选择
            this.$refs.dmtTabRef[0].changeSelectData(
                this.transferType,
                this.currentSelectVal
            )
            // this.currentSelectVal = "";
        },
        changeCyBrc20() {
            // TODO 币种/utxo选择
            this.$refs.brc20TabRef[0].changeSelectData(
                this.transferType,
                this.currentSelectVal
            )
            // this.currentSelectVal = "";
        },
        async next() {
            console.log(this.active, '当前活动标签索引');
            // 根据当前活动的标签页索引决定要使用的ref
            let currentRef;
            if (this.active === 3) { // 假设dmtTab对应的标签索引是3
                currentRef = this.$refs.dmtTabRef[0];
            } else if (this.active === 0) { // 假设brc20Tab对应的标签索引是0
                currentRef = this.$refs.brc20TabRef[0];
            }
            console.log(currentRef, '当前操作的ref');
            const active = currentRef.active;
            // 若 active 是其他值 则不做处理
            if (![0, 1, 2].includes(active)) return;
            let values = await currentRef.submit();
            if (typeof values === 'boolean' && !values) return;
            // TODO 提交
            console.log('values', values);
            this.$router.push({
                path: '/confirmOrder',
            });
        },
        clearCurtSelect() {
            this.currentSelectVal = ''
        },
        changeTabs() {
            console.log(this.active,'active');
            // if (this.active === 0) {
            //     this.lineWidth = '50px'
            //     this.lineDom.style.left = '-3%'
            // } else if(this.active === 1){
            //     this.lineDom.style.left = '-3%'
            // } else if(this.active === 2){
            //     this.lineDom.style.left = '-3%'
            // } 
            // else {
            //     this.lineWidth = '78px'
            //     this.lineDom.style.left = '-4%'
            // }
            if(this.active === 3){
                this.lineDom.style.left = '-5%'
            }else if(this.active === 4){
                this.lineDom.style.left = '-5.5%'
            }else{
                this.lineWidth = '50px'
                this.lineDom.style.left = '-3%'
            }
            
            
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variableName';
@import '../../style/mixin';
.content {
    height: 100vh;
    // display: flex;
    // flex-direction: column;
    // width: 100%;
    // height: 100vh;
    // top: 0;
    // left: 0;
    // overflow: hidden;
    // background-color: #ffffff;
    .select-cy {
        color: rgba(0, 0, 0, 0.4);
        height: torem(59);
        /deep/ .van-cell__title span {
            font-size: torem(16);
            width: torem(200);
            padding: torem(20) 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
    .select-cy-active {
        color: rgba(0, 0, 0, 0.8);
        padding-right: 0;
    }
}
.newBg {
    // padding-top: 2.2rem;
    // flex: 1;
    // height: 100vh;
    // overflow-y: auto;
    // overflow: auto;
    // padding: 0 torem(16) torem(16) torem(16);
    // .vantLine {
    //     position: absolute;
    //     width: torem(750);
    //     height: torem(10);
    //     // background-color: #f2f2f2;
    //     background-color: red;
    // }
    .vanTabs {
        /deep/ .van-tab__text {
            font-size: torem(16);
            // font-size: torem(16);
            // display: inline-block;
            // width: torem(100);
            // white-space:nowrap;
            // text-overflow:ellipsis;
            // overflow:hidden;
            padding: torem(10) 0;
        }
        /deep/ .van-tabs__content {
            padding: 0 torem(16) torem(16) torem(16);
        }
        /deep/ .van-tabs__nav {
            padding-left: torem(16);
        }
        //vant tabs
        /deep/ .van-tab {
            // position: relative;
            max-width: torem(109);
            // width: torem(51);
            // max-width: torem(109);
            padding-left: 0;
            padding-right: 0;
            justify-content: start;
            // justify-content: center;
        }
        /deep/ .van-tabs__nav--line {
            padding-bottom: 0;
        }
        /deep/ .van-tabs__line {
            width: torem(45) !important;
            // height: 4px;
            // left: -2%;
            height: torem(2);
            bottom: torem(1);
            background-color: rgba(0, 0, 0, 0.9);
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            height: torem(51);
        }
        /deep/ .van-tab--active {
            // color: red;
            color: rgba(0, 0, 0, 0.9);
            // font-size: torem(16);
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.9);
            // line-height: torem(19);
        }
    }
    .tab2 {
        margin-top: torem(105);
    }
    .footerBtns {
        position: fixed;
        width: 100%;
        bottom: torem(24);
        display: flex;
        justify-content: space-around;
        padding: 0 torem(16);
        /deep/ .van-button {
            width: torem(163.5);
            height: torem(44);
            border-radius: torem(4);
            font-size: torem(14);
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: 400;
        }
        .cancel {
            /deep/ .van-button {
                border: torem(1) solid rgba(0, 0, 0, 0.6);
                font-size: torem(14);
                font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.8);
            }
        }
        .nextTab2 {
            /deep/ .van-button {
                border: torem(1) solid rgba(0, 0, 0, 0.05);
                font-size: torem(14);
                font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.8);
                background-color: rgba(0, 0, 0, 0.05);
                border-radius: torem(4);
            }
        }
    }
}
// .ad-popup {
//   padding-bottom: torem(20);
//   .popup-title {
//     display: flex;
//     justify-content: space-between;
//     padding: torem(24) torem(16) torem(16);
//     @include sc(torem(18), #333);
//   }
//   .popup-content {
//     padding: torem(16);

//     /deep/ .van-cell-group {
//       margin-top: torem(12);
//       margin-bottom: torem(12);
//     }
//     /deep/ .van-cell {
//       padding-left: 0;
//     }
//     /deep/ .van-cell__title {
//       overflow: auto;
//     }
//     /deep/ .van-cell__title span {
//       /* display: flex; */
//       /* flex-wrap: wrap; */
//       /* word-wrap: break-word; */
//       word-break: normal;
//       width: auto;
//       display: block;
//       white-space: pre-wrap;
//       word-wrap: break-word;
//     }
//   }
//   .popup-btn-wrap {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     /* width: "80%";
//     margin: 0 auto; */
//     /deep/ .van-button {
//       width: torem(343);
//       margin: 0 auto;
//     }
//   }
//   /* /deep/ .van-cell-group {
//     margin-top: torem(12);
//   } */
// }
.my-ad {
    .my-ad-text {
        font-size: torem(10);
        color: rgba(0, 0, 0, 0.6);
    }
    /deep/ .van-cell__title {
        font-size: torem(10);
        color: rgba(0, 0, 0, 0.8);
    }
}
.lately-record {
    .lately-record-text {
        font-size: torem(10);
        color: rgba(0, 0, 0, 0.6);
    }
    .rd-cell {
        /deep/ .van-cell__title {
            font-size: torem(10);
            color: rgba(0, 0, 0, 0.4);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/InscriptionArea/Inscription.vue